import type { ComponentType } from "react";
import type { AnalyticsLayoutProps, ReportKind } from "../../types";
import { attendanceLayouts } from "../analytics/attendance/attendanceLayouts";
import { LeadsAnalytics } from "../analytics/events/LeadsAnalytics";
import { SuspicionAnalytics } from "../analytics/events/SuspicionAnalytics";
import { TasksAnalytics } from "../analytics/events/TasksAnalytics";
import { ZoneExitsAnalytics } from "../analytics/events/ZoneExitsAnalytics";
import { GenericAnalytics } from "./GenericAnalytics";

export type { AnalyticsLayoutProps } from "../../types";

/**
 * Kind → analitika layout'i registri (spec §4 — merge'da umumiy fayl).
 *
 * ⚠️ Hodisa/dala layoutlari shu yerda, davomat layoutlari
 * `attendanceLayouts.ts` dan spread qilinadi (F bloki parallel
 * yozilgan). Kalit yo'q kind `GenericAnalytics` ga tushadi — sahifa
 * bo'sh qolmaydi.
 */
export const analyticsLayouts: Partial<Record<ReportKind, ComponentType<AnalyticsLayoutProps>>> = {
	...attendanceLayouts,
	// biome-ignore lint/style/useNamingConvention: kalit — backend ReportKind qiymati
	zone_exits: ZoneExitsAnalytics,
	// biome-ignore lint/style/useNamingConvention: kalit — backend ReportKind qiymati
	fake_location: SuspicionAnalytics,
	violations: SuspicionAnalytics,
	leads: LeadsAnalytics,
	tasks: TasksAnalytics,
};

export function resolveAnalyticsLayout(kind: ReportKind): ComponentType<AnalyticsLayoutProps> {
	return analyticsLayouts[kind] ?? GenericAnalytics;
}
